(function(){
  var root=document.getElementById('ax-idd');
  if(!root) return;
  var fill=root.querySelector('[data-progress]'), topBtn=root.querySelector('[data-top]');
  function onScroll(){
    var h=document.documentElement, max=h.scrollHeight-h.clientHeight;
    var p=max>0?h.scrollTop/max:0;
    if(fill) fill.style.width=(p*100)+'%';
    if(topBtn) topBtn.classList.toggle('show',h.scrollTop>600);
  }
  document.addEventListener('scroll',onScroll,{passive:true}); onScroll();
  if(topBtn) topBtn.addEventListener('click',function(){window.scrollTo({top:0,behavior:'smooth'});});

  // TOC from H2s in the article body
  var rte=root.querySelector('[data-rte]'), list=root.querySelector('[data-toc] ul'), toc=root.querySelector('[data-toc]');
  var heads=rte?Array.prototype.slice.call(rte.querySelectorAll('h2')):[];
  if(heads.length>1 && list){
    heads.forEach(function(h,i){
      if(!h.id){h.id='sec-'+(i+1);}
      var n=('0'+(i+1)).slice(-2);
      var li=document.createElement('li'), a=document.createElement('a');
      a.href='#'+h.id; a.innerHTML='<span class="num">'+n+'</span><span>'+h.textContent+'</span>';
      li.appendChild(a); list.appendChild(li);
    });
    var links=Array.prototype.slice.call(list.querySelectorAll('a'));
    var spy=new IntersectionObserver(function(es){
      es.forEach(function(en){ if(en.isIntersecting){ links.forEach(function(l){l.classList.toggle('on',l.getAttribute('href')==='#'+en.target.id);}); } });
    },{rootMargin:'-30% 0px -60% 0px'});
    heads.forEach(function(h){spy.observe(h);});
  } else if(toc){ toc.style.display='none'; }

  // share
  function share(){
    if(navigator.share){navigator.share({title:document.title,url:location.href}).catch(function(){});}
    else if(navigator.clipboard){navigator.clipboard.writeText(location.href);}
  }
  Array.prototype.slice.call(root.querySelectorAll('[data-share]')).forEach(function(b){b.addEventListener('click',function(e){e.preventDefault();share();});});

  // reveal
  if(!window.matchMedia('(prefers-reduced-motion:reduce)').matches){
    var io=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting){en.target.classList.add('in');io.unobserve(en.target);}});},{threshold:.12});
    Array.prototype.slice.call(root.querySelectorAll('.reveal')).forEach(function(el){io.observe(el);});
  } else { Array.prototype.slice.call(root.querySelectorAll('.reveal')).forEach(function(el){el.classList.add('in');}); }
})();
